import {useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";
import DeleteQuestionModal from  "../../modals/DeleteQuestionModal.jsx";

function FibQuestionsRenderer({
  handleFibQuestionChange,
  handleFibAnswerChange,
  handleFibQuestionsEdit,
  handleFibAnswersEdit,
  handleFibQuestionDelete,
  index,
  question,
}) {

  const normalizedQuestion = normalizeQuestion(question, "fib");
  
   const [showDeleteModal, setShowDeleteModal] = useState(false);

   
   // Handler for opening delete modal
  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

    // Handler for confirming delete
  const handleConfirmDelete = () => {
    handleFibQuestionDelete(normalizedQuestion.index);
  };
  return (
    <>
      {/* {fibQuestions.map((fibQuestion, index) => ( */}
      <div className="mb-4  border-slate-100 border-2 hover:border-dotted  hover:border-[#f4833d]  rounded question-answer-container p-4">
        <div className="flex place-content-between">
          <p className="flex">
            <span>{index + 1}.&nbsp; </span>{" "}
            {question.editing ? (
              <div
                contentEditable="true"
                id={`question-${question.index}`}
                className={` `}
                onBlur={(e) => {
                  handleFibQuestionChange(question.index, e.target.textContent);
                  handleFibQuestionsEdit(question.index);
                }}
                dangerouslySetInnerHTML={{ __html: question.Question }}
              />
            ) : (
              <span
                onClick={() => handleFibQuestionsEdit(question.index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{ __html: question.Question }}
              />
            )}
          </p>
          <div className="flex edit-delete-icons">
            <Tooltip
              title="Edit"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleFibQuestionsEdit(question.index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>{" "}
              </button>
            </Tooltip>

            <Tooltip
              title="Delete"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={handleDeleteClick}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>{" "}
              </button>
            </Tooltip>
          </div>
        </div>

        <p className="flex">
          <p className="font-semibold me-2">Answer:&nbsp;</p>{" "}
          {question.editingAnswer ? (
            <div
              contentEditable
              className="editable-answer"
              onBlur={(e) => {
                handleFibAnswerChange(question.index, e.target.textContent);
                handleFibAnswersEdit(index);
              }}
              dangerouslySetInnerHTML={{ __html: question.Answer }}
            />
          ) : (
            <span
              onClick={() => handleFibAnswersEdit(question.index)}
              className="cursor-pointer"
              dangerouslySetInnerHTML={{ __html: question.Answer }}
            />
          )}
        </p>
      </div>
       <DeleteQuestionModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirmDelete={handleConfirmDelete}
          questionNumber={index + 1}
        />
    </>
  );
}

export default FibQuestionsRenderer;
